import { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import config from 'constants/config'
import Heading from 'LuxKit/Typography/Heading'
import HowItWorksItems from 'components/Common/HowItWorks/HowItWorksItems'
import { useIntl } from 'react-intl'

const SizedHowItWorks = styled(HowItWorksItems)`
  min-width: ${rem(320)};
`

function HowItWorksBanner() {
  const intl = useIntl()
  return <Pane border="light-foreground" borderRadius="S" padding="40 20">
    <Heading variant="heading3" align="center">
      {intl.formatMessage({
        id: 'ZtnzD2ko3Zvv7bAzNBMQ',
        defaultMessage: 'Why you should book with us',
        description: 'Section heading for why book with us section in the front page section',
      })}
    </Heading>
    <SizedHowItWorks items={config.offerList.howItWorks.hotel} />
  </Pane>
}

export default memo(HowItWorksBanner)
